import {
    Box,
    Hidden,
    Theme,
    Typography
} from "@mui/material";
import { SchemeInfoProps } from "./types";
import { checkImageExists } from "../../utils/utilityFunctions";

function Circle({ backgroundColor = "text.secondary" }: { backgroundColor?: string; }) {
    return (
        <Box
            sx={{
                width: "3px",
                height: "3px",
                backgroundColor,
                alignSelf: "center",
                borderRadius: "50%",
            }}
        />
    )
}

export default function SchemeInfo({
    schemeImg,
    schemeName,
    schemeCategory,
    schemeSubCategory,
    schemeRisk,
    schemeRiskColor,
    amcId
}: SchemeInfoProps): JSX.Element {
    const amcIds = ['BDOTR', 'BPIAMC']

    const checkAmcId = amcIds.includes(amcId ?? '') ? amcId?.toLowerCase() : amcId;
    return (
        <>
            <Hidden lgUp>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        columnGap: "15px",
                        maxWidth: "100%",
                        width: "100%",
                    }}
                >
                    <Box
                        component="img"
                        src={checkImageExists(`${checkAmcId}`) ? `/images/amcIcons/${checkAmcId}.svg` : `/images/amcIcons/default.svg`}
                        sx={{
                            width: '50px',
                            height: '50px',
                            borderRadius: '8px',
                            objectFit: "contain"
                        }}
                        alt={schemeName}
                    />
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            flex: 1,
                            minWidth: 0,
                            rowGap: "7px"
                        }}
                    >
                        <Typography
                            variant="body_600"
                            sx={(theme: Theme) => ({
                                color: theme.palette.text.primary,
                                lineHeight: "22.5px",
                                letterSpacing: "0.02px"
                            })}
                            title={schemeName}
                        >
                            {schemeName}
                        </Typography>
                        <Box
                            sx={{
                                display: "flex",
                                columnGap: "10px",
                                alignItems: "center",
                                flexWrap: "wrap",
                            }}
                        >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.secondary,
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px"
                                })}
                                title={schemeCategory}
                            >
                                {schemeCategory}
                            </Typography>
                            <Box>
                                <Circle />
                            </Box>
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.secondary,
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px"
                                })}
                                title={schemeSubCategory}
                            >
                                {schemeSubCategory}
                            </Typography>
                            {!!schemeRisk && schemeRisk.toLowerCase() !== "null" && (
                                <>
                                    <Box>
                                        <Circle />
                                    </Box>
                                    <Typography
                                        variant="body_500"
                                        sx={{
                                            color: schemeRiskColor,
                                            lineHeight: "20px",
                                            letterSpacing: "0.02px"
                                        }}
                                        title={schemeRisk}
                                    >
                                        {schemeRisk}
                                    </Typography>
                                </>
                            )}
                        </Box>
                    </Box>
                </Box>
            </Hidden>
            <Hidden lgDown>
                <Box
                    sx={{
                        display: "flex",
                        columnGap: "10px"
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            columnGap: "15px",
                        }}
                    >
                        <Box
                            component="img"
                            src={checkImageExists(`${checkAmcId}`) ? `/images/amcIcons/${checkAmcId}.svg` : `/images/amcIcons/default.svg`}
                            sx={{
                                width: '50px',
                                height: '50px',
                                borderRadius: '8px',
                                objectFit: "contain"
                            }}
                            alt={schemeName}
                        />
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "10px"
                        }}
                    >

                        <Box sx={{ display: "flex", columnGap: "5px" }}>
                            <Typography
                                variant="body_600"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    lineHeight: "22.5px",
                                    letterSpacing: "0.02px"
                                })}
                                title={schemeName}
                            >
                                {schemeName}
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                columnGap: "12px"
                            }}
                        >
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.secondary,
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px"
                                })}
                                title={schemeCategory}
                            >
                                {schemeCategory}
                            </Typography>
                            <Box>
                                <Circle />
                            </Box>
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.secondary,
                                    lineHeight: "20px",
                                    letterSpacing: "0.02px"
                                })}
                                title={schemeSubCategory}
                            >
                                {schemeSubCategory}
                            </Typography>
                            {!!schemeRisk && schemeRisk.toLowerCase() !== "null" && (
                                <>
                                    <Box>
                                        <Circle />
                                    </Box>
                                    <Typography
                                        variant="body_500"
                                        sx={{
                                            color: schemeRiskColor,
                                            lineHeight: "20px",
                                            letterSpacing: "0.02px"
                                        }}
                                        title={schemeRisk}
                                    >
                                        {schemeRisk}
                                    </Typography>
                                </>
                            )}
                        </Box>
                    </Box>
                </Box>
            </Hidden>
        </>
    )
}